module.exports = __webpack_public_path__ + "img/ic_fly.8131a788.png";